export enum UserType {
  RETAIL = 'retail',
  INSTITUTIONAL = 'institutional',
}
